import { httpRequest, endpoint } from "@cirrus/core/http"

// TODO: Delete if not used
export const titleGet = async ({ id, submissionId }) =>
  await httpRequest.get(endpoint.withRoot(`/api/marking/${id}/results/${submissionId}/title`))

export const submittedGet = async ({ id, markingRole }) =>
  await httpRequest.get(endpoint.withRoot(`/api/marking/${markingRole}/${id}/submitted`))

// TODO: Delete if not used
export const itemsGet = async ({ id, submissionId, markingRole, filters = {} }) => {
  const queryParams = {
    params: {
      type: filters.type || null,
      answersType: filters.answersType || null,
    },
  }

  return await httpRequest.get(
    endpoint.withRoot(`/api/marking/${markingRole}/${id}/results/${submissionId}/detailed`),
    queryParams,
  )
}
